import { isLegacyBilling } from './billingVersion'

const DESK_REDIRECT_NEW_WORKSPACE_CUTOFF = new Date('2026-05-07T00:00:00Z').getTime()

export const isDeskRedirectEligible = (workspace: { billingVersion: string; createdAt: string }): boolean => {
  const isNewWorkspace = new Date(workspace.createdAt).getTime() >= DESK_REDIRECT_NEW_WORKSPACE_CUTOFF
  return !isLegacyBilling(workspace) || isNewWorkspace
}
